import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Organizacja } from '../../../models/organizacja';
import { PreviewDataWrapperComponent } from '../../preview-data-wrapper/preview-data-wrapper.component';
import { BankAccountFormatPipe } from '../../../pipes/bank-account-format.pipe';

@Component({
  selector: 'app-preview-organization-account-number',
  imports: [PreviewDataWrapperComponent, BankAccountFormatPipe],
  templateUrl: './preview-organization-account-number.component.html',
  styleUrl: './preview-organization-account-number.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewOrganizationAccountNumberComponent {
  public readonly organization = input<Organizacja>();
}
